/**
 * Created by ronmarsiano on 06/02/2018.
 */
mainApp.directive('osIcons', function() {
    return {
        templateUrl: '/public/directives/osIcons.html',
        scope: {
            android: '@?',
            windows: '@?',
            linux: '@?',
            ios: '@?',
            mac: '@?'
        }
    };
});